module.exports = __webpack_public_path__ + "static/media/BannerD1.13f285b1.png";